import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import bg from './locales/bg.json';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import ro from './locales/ro.json';
import tr from './locales/tr.json';
import mt from './locales/mt.json';

//const languageDetector = new LanguageDetector();
/*languageDetector.addDetector({
    name: 'osLocale',
    lookup() {
        console.log('OS locale detector is called');
        try {
            console.log('OS locale is probably', Intl.DateTimeFormat().resolvedOptions());
            return Intl.DateTimeFormat().resolvedOptions().locale;
        } catch {
            return undefined
        }
    },
});*/

i18n.use(LanguageDetector).use(initReactI18next).init({
    resources: {
        bg, de, en, es, fr, it, pt, ro, tr, mt,
    },
    detection: {
        order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
    },
    fallbackLng: "bg",
    interpolation: {
        escapeValue: false
    }
});

export default i18n;